import * as React from 'react';
import { CarouselProvider, Slider, Slide } from 'pure-react-carousel';

import '../../../../node_modules/pure-react-carousel/dist/react-carousel.es.css';
import * as s from './ScrollableSlider.css';

export interface IScrollableSliderProps {
  slides: React.ReactNode[];
  size: { width: number; height: number };
  onSlideMouseDown(e: React.MouseEvent<HTMLDivElement>): void;
  onSlideClickCapture(e: React.MouseEvent<HTMLDivElement>): void;
  visibleSlides: number;
}

export const ScrollableSlider: React.FC<IScrollableSliderProps> = ({
  slides,
  size,
  onSlideMouseDown,
  onSlideClickCapture,
  visibleSlides,
}) => {
  return (
    <div className={s['container']}>
      <CarouselProvider
        visibleSlides={visibleSlides}
        naturalSlideWidth={size.width}
        naturalSlideHeight={size.height}
        totalSlides={slides.length}
        className={s['carousel']}
      >
        <Slider className={s['slider']}>
          {slides.map((slide, index) => (
            <Slide key={index} index={index} onMouseDown={onSlideMouseDown} onClickCapture={onSlideClickCapture}>
              <div className={s['slide']}>{slide}</div>
            </Slide>
          ))}
        </Slider>
      </CarouselProvider>
    </div>
  );
};
